import { render, staticRenderFns } from "./selectzf.vue?vue&type=template&id=53133e7c&scoped=true&"
import script from "./selectzf.vue?vue&type=script&lang=js&"
export * from "./selectzf.vue?vue&type=script&lang=js&"
import style0 from "./selectzf.vue?vue&type=style&index=0&id=53133e7c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53133e7c",
  null
  
)

export default component.exports